var styles = {"root":"stepper-static-item--root","left":"stepper-static-item--left","right":"stepper-static-item--right","center":"stepper-static-item--center","justify":"stepper-static-item--justify","image":"stepper-static-item--image","content":"stepper-static-item--content","heading":"stepper-static-item--heading","text":"stepper-static-item--text"};

export { styles as default };
//# sourceMappingURL=StepperStaticItem.module.esm.js.map
